import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'rentalDuration',
  standalone: true,
})
export class RentalDurationPipe implements PipeTransform {
  transform(pickupDate: string | Date, dropoffDate: string | Date): string {
    if (!pickupDate || !dropoffDate) {
      return '';
    }

    const START = new Date(pickupDate);
    const END = new Date(dropoffDate);

    const DIFF_MS = END.getTime() - START.getTime();
    if (DIFF_MS <= 0) {
      return '0 hours';
    }

    return this.formatDuration(START, END, DIFF_MS);
  }

  private formatDuration(start: Date, end: Date, diffMs: number): string {
    const TOTAL_HOURS = diffMs / (1000 * 60 * 60);
    const TOTAL_DAYS = TOTAL_HOURS / 24;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { years, months } = this.calculateYearsAndMonths(start, end);

    if (years >= 1) {
      return this.formatUnit(years, 'year');
    }

    if (months >= 1) {
      return this.formatUnit(months, 'month');
    }

    if (TOTAL_DAYS >= 1) {
      return this.formatUnit(Math.ceil(TOTAL_DAYS), 'day');
    }

    return this.formatUnit(Math.ceil(TOTAL_HOURS), 'hour');
  }

  private calculateYearsAndMonths(start: Date, end: Date): { years: number; months: number } {
    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();

    if (end.getDate() < start.getDate()) {
      months -= 1;
    }

    if (months < 0) {
      years -= 1;
      months += 12;
    }

    return { years, months };
  }

  private formatUnit(value: number, unit: string): string {
    return `${value} ${unit}${value > 1 ? 's' : ''}`;
  }
}
